import styled from 'styled-components';

export const THead = styled.thead`
  tr {
    padding-bottom: 1rem;
    text-align: center;
    text-transform: 'uppercase';
  }
`;
